var exports = {
  "k": "xa15a2ab7--e5a45e--container",
  "A": "xa15a2ab7--e5a45e--item",
};

module.exports = exports;
